import type { getOneOrderOutput } from "@/api/custom_types";
import { useTranslation } from "@/hooks";
import OrdersSingleAction from "@/pages/orders/OrdersSingleAction";
import { getTimeSinceText } from "@/utils/timestamp";
import { getOrderEmail } from "@/utils/tools";
import { Card, Typography } from "@st-marketplace/ui";

interface OrderDetailsHeader {
	order: getOneOrderOutput;
}

function OrderDetailsHeader({ order }: OrderDetailsHeader) {
	const { t, lang } = useTranslation();

	return (
		<div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
			<div className="mb-2">
				<Typography variant="title-md" as="h1" className="mb-2">
					{t("orderInfo.title")}
				</Typography>
				<div className="flex flex-col gap-2 md:flex-row">
					<Typography className="text-secondary-icon">
						{order ? getOrderEmail(order) : ""}
					</Typography>
					<Typography className="text-secondary-icon">
						{t("orderInfo.startedAt")}:{" "}
						{order && getTimeSinceText(order.created_date, t, lang)}
					</Typography>
				</div>
			</div>
			{order && (
				<Card className="rounded-md">
					<OrdersSingleAction selectedOrder={order} />
				</Card>
			)}
		</div>
	);
}

export default OrderDetailsHeader;
